import { useState } from "react";
import { useTranslation } from "react-i18next";

interface FaqItem {
  q: string;
  a: string;
}

export default function FaqSection() {
  const { t } = useTranslation();
  const faq = t("faq.items", { returnObjects: true }) as unknown as FaqItem[];
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <div className="mx-auto max-w-3xl">
          <h2 className="text-center font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
            {t("faq.title")}
          </h2>
          <p className="mt-3 text-center text-sm text-foreground-600 md:text-base">
            {t("faq.subtitle")}
          </p>

          <div className="mt-8 space-y-3">
            {faq.map((item, i) => {
              const isOpen = openIndex === i;
              return (
                <div
                  key={i}
                  className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-heading text-sm font-semibold text-foreground-900 md:text-base">
                      {item.q}
                    </span>
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600">
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5">
                      <p className="text-sm leading-relaxed text-foreground-600">
                        {item.a}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}